module.exports = __webpack_public_path__ + "static/img/zj01.a0116b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/zj01.png
// module id = 138
// module chunks = 0